import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any;
  DateTime: any;
};

export type Ability = {
  __typename?: 'Ability';
  name: Scalars['String'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  causer?: Maybe<User>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['String']>;
};

export type ActivityLogsResult = {
  __typename?: 'ActivityLogsResult';
  logs?: Maybe<Array<Maybe<ActivityLog>>>;
  total: Scalars['Int'];
};

export type AffiliateCode = {
  __typename?: 'AffiliateCode';
  archivedAt?: Maybe<Scalars['DateTime']>;
  code: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  type: Scalars['String'];
  typeId?: Maybe<Scalars['String']>;
};

export type AffiliateCodeFilters = {
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  showArchived?: InputMaybe<Scalars['Boolean']>;
};

export type AffiliateCodeResult = {
  __typename?: 'AffiliateCodeResult';
  items?: Maybe<Array<AffiliateCode>>;
  total: Scalars['Int'];
};

export type AlgoliaSearchParams = {
  __typename?: 'AlgoliaSearchParams';
  searchKey: Scalars['String'];
  searchableAs: Scalars['String'];
};

export type AmountByFundAccount = {
  amount: Scalars['Float'];
  fundAccountPrefixedId: Scalars['String'];
};

export type Attendance = {
  __typename?: 'Attendance';
  attendanceDetails?: Maybe<Array<AttendanceDetail>>;
  attendanceType: AttendanceType;
  date: Scalars['Date'];
  dateFormatted: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  total: Scalars['Int'];
};

export type AttendanceDetail = {
  __typename?: 'AttendanceDetail';
  attendance: Scalars['Int'];
  attendanceLocation: AttendanceLocation;
  prefixedId: Scalars['ID'];
};

export type AttendanceDetailInput = {
  attendance: Scalars['Int'];
  attendanceLocationPrefixedId: Scalars['String'];
  prefixedId?: InputMaybe<Scalars['ID']>;
};

export type AttendanceLocation = {
  __typename?: 'AttendanceLocation';
  canBeRemoved: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
};

export type AttendanceType = {
  __typename?: 'AttendanceType';
  canBeRemoved: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
};

export type AttendancesFilters = {
  dateRange?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AttendancesResult = {
  __typename?: 'AttendancesResult';
  allItems: Array<Attendance>;
  items: Array<Attendance>;
  totalAttendance: Scalars['Int'];
  totalResults: Scalars['Int'];
};

export type Attribute = {
  __typename?: 'Attribute';
  id: Scalars['ID'];
  key: Scalars['String'];
  person: Person;
  value: Scalars['String'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  amount: Scalars['Float'];
  customerPortalUrl?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  hasDiscount?: Maybe<Scalars['Boolean']>;
  nextAmount: Scalars['Float'];
  nextPaymentDate?: Maybe<Scalars['DateTime']>;
  pmLastFour?: Maybe<Scalars['String']>;
  subscription: Subscription;
  subscriptionItems?: Maybe<Array<SubscriptionItem>>;
};

export type Chart = {
  __typename?: 'Chart';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  series: Array<ChartSeries>;
};

export type ChartDataPoint = {
  __typename?: 'ChartDataPoint';
  date?: Maybe<Scalars['Date']>;
  x?: Maybe<Scalars['String']>;
  y?: Maybe<Scalars['Float']>;
};

export type ChartReportResult = {
  __typename?: 'ChartReportResult';
  chart: Chart;
  resultItems: Array<ReportResultItem>;
};

export type ChartSeries = {
  __typename?: 'ChartSeries';
  data: Array<ChartDataPoint>;
  name: Scalars['String'];
};

export type ConnectStripeResult = {
  __typename?: 'ConnectStripeResult';
  onboardUrl?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<ContactPhone>>>;
  prefixedId: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  prefixedId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  contactAgreementAccepted?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type ContactPhoneInput = {
  contactAgreementAccepted: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  phone: Scalars['String'];
  prefixedId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  featuredImage?: Maybe<Image>;
  html?: Maybe<Scalars['String']>;
  htmlEs?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type Contribution = {
  __typename?: 'Contribution';
  amount?: Maybe<Scalars['Float']>;
  amountFormatted?: Maybe<Scalars['String']>;
  contributionFunds?: Maybe<Array<ContributionFund>>;
  coverProcessingFee: Scalars['Boolean'];
  date: Scalars['Date'];
  dateFormatted?: Maybe<Scalars['String']>;
  donor: Donor;
  donorPrefixedId: Scalars['ID'];
  donorTypeLabel: Scalars['String'];
  exchangeAmount?: Maybe<Scalars['Float']>;
  exchangeDescription?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  isDeposited?: Maybe<Scalars['Boolean']>;
  isExchange: Scalars['Boolean'];
  media: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
  netAmount?: Maybe<Scalars['Float']>;
  organization: Organization;
  prefixedId: Scalars['ID'];
  processorPaymentId?: Maybe<Scalars['String']>;
  recurringGiving?: Maybe<RecurringGiving>;
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
};

export type ContributionFilters = {
  byPrefixedId?: InputMaybe<Array<Scalars['ID']>>;
  contributionType?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<Array<Scalars['String']>>;
  depositPrefixedId?: InputMaybe<Scalars['String']>;
  donor?: InputMaybe<Scalars['String']>;
  fund?: InputMaybe<Array<Scalars['String']>>;
  includeTotalAmount?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  withEmail?: InputMaybe<Scalars['Boolean']>;
  withoutDepositOnly?: InputMaybe<Scalars['Boolean']>;
};

export type ContributionFund = {
  __typename?: 'ContributionFund';
  amount: Scalars['Float'];
  contribution: Contribution;
  fee: Scalars['Float'];
  fundAccount: FundAccount;
  isDeductible: Scalars['Boolean'];
  netAmount: Scalars['Float'];
  prefixedId: Scalars['ID'];
};

export type ContributionFundInput = {
  amount?: InputMaybe<Scalars['Float']>;
  fundAccountPrefixedId?: InputMaybe<Scalars['String']>;
  isDeductible: Scalars['Boolean'];
  prefixedId?: InputMaybe<Scalars['ID']>;
};

export type ContributionFundsFilters = {
  donor?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  firstTimeGiving?: InputMaybe<Scalars['Boolean']>;
  fund?: InputMaybe<Array<Scalars['String']>>;
  max?: InputMaybe<Scalars['Float']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  min?: InputMaybe<Scalars['Float']>;
  noAddress?: InputMaybe<Scalars['Boolean']>;
  noEmail?: InputMaybe<Scalars['Boolean']>;
  noPhone?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type ContributionFundsResult = {
  __typename?: 'ContributionFundsResult';
  items: Array<ContributionFund>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalFee?: Maybe<Scalars['Float']>;
  totalNetAmount?: Maybe<Scalars['Float']>;
  totalResults: Scalars['Int'];
};

export type ContributionTotal = {
  __typename?: 'ContributionTotal';
  donor: Donor;
  totalAmount: Scalars['Float'];
  totalFee: Scalars['Float'];
  totalNetAmount: Scalars['Float'];
};

export type ContributionWithFundAccountNames = {
  __typename?: 'ContributionWithFundAccountNames';
  amount?: Maybe<Scalars['Float']>;
  amountFormatted?: Maybe<Scalars['String']>;
  contributionFunds?: Maybe<Array<ContributionFund>>;
  coverProcessingFee: Scalars['Boolean'];
  date: Scalars['Date'];
  dateFormatted?: Maybe<Scalars['String']>;
  donor: Donor;
  donorPrefixedId: Scalars['ID'];
  donorTypeLabel: Scalars['String'];
  exchangeAmount?: Maybe<Scalars['Float']>;
  exchangeDescription?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Float']>;
  fundAccountNames?: Maybe<Scalars['String']>;
  isDeposited?: Maybe<Scalars['Boolean']>;
  isExchange: Scalars['Boolean'];
  media: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
  netAmount?: Maybe<Scalars['Float']>;
  organization: Organization;
  prefixedId: Scalars['ID'];
  processorPaymentId?: Maybe<Scalars['String']>;
  recurringGiving?: Maybe<RecurringGiving>;
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['DateTime']>;
};

export type ContributionsReportFilters = {
  customDateEnd?: InputMaybe<Scalars['String']>;
  customDateStart?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
};

export type ContributionsResult = {
  __typename?: 'ContributionsResult';
  items: Array<Contribution>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalFee?: Maybe<Scalars['Float']>;
  totalNetAmount?: Maybe<Scalars['Float']>;
  totalResults: Scalars['Int'];
};

export type ContributionsTotalFilters = {
  endDate?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  noAddress?: InputMaybe<Scalars['Boolean']>;
  noEmail?: InputMaybe<Scalars['Boolean']>;
  noPhone?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type ContributionsTotalResult = {
  __typename?: 'ContributionsTotalResult';
  items: Array<ContributionTotal>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalFee?: Maybe<Scalars['Float']>;
  totalNetAmount?: Maybe<Scalars['Float']>;
  totalResults: Scalars['Int'];
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  existingPersonPrefixedId?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type Deposit = {
  __typename?: 'Deposit';
  amount?: Maybe<Scalars['Float']>;
  contributions: Array<Contribution>;
  date: Scalars['Date'];
  dateFormatted?: Maybe<Scalars['String']>;
  depositAccount: DepositAccount;
  fee?: Maybe<Scalars['Float']>;
  memo?: Maybe<Scalars['String']>;
  netAmount?: Maybe<Scalars['Float']>;
  prefixedId: Scalars['ID'];
};

export type DepositAccount = {
  __typename?: 'DepositAccount';
  archivedAt?: Maybe<Scalars['DateTime']>;
  deposits: Array<Maybe<Deposit>>;
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  organization: Organization;
  prefixedId: Scalars['ID'];
  type: Scalars['String'];
};

export type DepositFilters = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DepositsResult = {
  __typename?: 'DepositsResult';
  items: Array<Deposit>;
  totalAmount: Scalars['Float'];
  totalFee?: Maybe<Scalars['Float']>;
  totalNetAmount?: Maybe<Scalars['Float']>;
  totalResults: Scalars['Int'];
};

export type Donor = DonorOrganization | Person;

export type DonorActivity = {
  __typename?: 'DonorActivity';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DonorContributionFilters = {
  contributionType?: InputMaybe<Scalars['String']>;
  donor?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DonorContributionsResult = {
  __typename?: 'DonorContributionsResult';
  items: Array<ContributionWithFundAccountNames>;
  totalResults: Scalars['Int'];
};

export type DonorDashboardReport = {
  __typename?: 'DonorDashboardReport';
  activeRecurringGifts: Scalars['Int'];
  singleGifts: Scalars['Int'];
  totalGifts: Scalars['Float'];
};

export type DonorFilters = {
  depositPrefixedId?: InputMaybe<Scalars['String']>;
  donor?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  firstTimeGiving?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  listAll?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  noAddress?: InputMaybe<Scalars['Boolean']>;
  noEmail?: InputMaybe<Scalars['Boolean']>;
  noPhone?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Scalars['String']>;
  organizationPrefixedId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DonorItem = {
  __typename?: 'DonorItem';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  primaryPhone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DonorOrganization = {
  __typename?: 'DonorOrganization';
  contact?: Maybe<Contact>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizations?: Maybe<Array<Organization>>;
  pivot?: Maybe<OrganizationDonorPivot>;
  prefixedId: Scalars['ID'];
};

export type DonorOrganizationFilters = {
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  showArchived?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type DonorOrganizationsResult = {
  __typename?: 'DonorOrganizationsResult';
  items: Array<DonorOrganization>;
  totalResults: Scalars['Int'];
};

export type DonorRecurringGivingFilters = {
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type DonorRecurringGivingsResult = {
  __typename?: 'DonorRecurringGivingsResult';
  items: Array<RecurringGiving>;
  totalResults: Scalars['Int'];
};

export type DonorsResult = {
  __typename?: 'DonorsResult';
  items: Array<DonorItem>;
  totalResults: Scalars['Int'];
};

export type DonorsSummaryReportResult = {
  __typename?: 'DonorsSummaryReportResult';
  donatedInDateRange: Scalars['Int'];
  donorsMissingInformation: Scalars['Int'];
  donorsWithoutEmail: Scalars['Int'];
  totalDonors: Scalars['Int'];
};

export type EventTemplate = {
  __typename?: 'EventTemplate';
  canBeDeleted: Scalars['Boolean'];
  eventType: EventType;
  groups?: Maybe<Array<Group>>;
  name: Scalars['String'];
  organization: Organization;
  prefixedId: Scalars['ID'];
};

export type EventTemplateFilters = {
  type?: InputMaybe<Scalars['String']>;
};

export type EventType = {
  __typename?: 'EventType';
  module: Module;
  name: Scalars['String'];
};

export type Family = {
  __typename?: 'Family';
  name?: Maybe<Scalars['String']>;
  people?: Maybe<Array<Person>>;
  pivot?: Maybe<FamilyPersonPivot>;
  prefixedId: Scalars['ID'];
};

export type FamilyPersonPivot = {
  __typename?: 'FamilyPersonPivot';
  isPrimary: Scalars['Boolean'];
  role: Scalars['String'];
};

export type FinanceReportFilters = {
  range?: InputMaybe<Scalars['String']>;
};

export type FinanceReportResult = {
  __typename?: 'FinanceReportResult';
  archivedDonors: Scalars['String'];
  newDonors: Scalars['String'];
  totalDonors: Scalars['String'];
};

export type FundAccount = {
  __typename?: 'FundAccount';
  archivedAt?: Maybe<Scalars['DateTime']>;
  canDisableIsOnlineGivingVisible: Scalars['Boolean'];
  contributionFunds: Array<ContributionFund>;
  isDefault: Scalars['Boolean'];
  isOnlineGivingVisible: Scalars['Boolean'];
  name: Scalars['String'];
  organization: Organization;
  prefixedId: Scalars['ID'];
};

export type FundAccountInput = {
  isOnlineGivingVisible: Scalars['Boolean'];
  prefixedId: Scalars['ID'];
};

export type Group = {
  __typename?: 'Group';
  archivedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  groupType?: Maybe<GroupType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  organization: Organization;
  people?: Maybe<Array<Person>>;
  prefixedId: Scalars['ID'];
};

export type GroupFilters = {
  showArchived?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GroupInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type GroupType = {
  __typename?: 'GroupType';
  name: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Invite = {
  __typename?: 'Invite';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  prefixedId: Scalars['ID'];
  tenantId: Scalars['Int'];
};

export type KdsMigrationQueue = {
  __typename?: 'KdsMigrationQueue';
  currentRow?: Maybe<Scalars['Int']>;
  currentTable?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['String']>;
  kdsOrganizationName?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['String']>;
  successful?: Maybe<Scalars['Boolean']>;
};

export type KdsOrganization = {
  __typename?: 'KdsOrganization';
  accountId?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['ID']>;
  organizationName?: Maybe<Scalars['String']>;
};

export type KdsRowCount = {
  __typename?: 'KdsRowCount';
  count: Scalars['Int'];
  tableName: Scalars['String'];
};

export type KdsTablesResult = {
  __typename?: 'KdsTablesResult';
  creditedAmount: Scalars['Float'];
  rowsCount: Array<KdsRowCount>;
};

export type LaunchAdminPhase = {
  __typename?: 'LaunchAdminPhase';
  description?: Maybe<Scalars['String']>;
  descriptionEs?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  launchAdminTopics?: Maybe<Array<Maybe<LaunchAdminTopic>>>;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LaunchAdminPhaseData = {
  description?: InputMaybe<Scalars['String']>;
  descriptionEs?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  order?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
  templatePrefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: InputMaybe<Scalars['String']>;
};

export type LaunchAdminTask = {
  __typename?: 'LaunchAdminTask';
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LaunchAdminTaskData = {
  order?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: InputMaybe<Scalars['String']>;
  topicPrefixedId?: InputMaybe<Scalars['ID']>;
};

export type LaunchAdminTemplate = {
  __typename?: 'LaunchAdminTemplate';
  description?: Maybe<Scalars['String']>;
  descriptionEs?: Maybe<Scalars['String']>;
  explainerUrl?: Maybe<Scalars['String']>;
  heroImageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  minWeeks: Scalars['Int'];
  name: Scalars['String'];
  nameEs?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  subheader: Scalars['String'];
  subheaderEs?: Maybe<Scalars['String']>;
};

export type LaunchAdminTemplateData = {
  description?: InputMaybe<Scalars['String']>;
  descriptionEs?: InputMaybe<Scalars['String']>;
  explainerUrl?: InputMaybe<Scalars['String']>;
  heroImageUrl?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  minWeeks: Scalars['Int'];
  name: Scalars['String'];
  nameEs?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
  subheader: Scalars['String'];
  subheaderEs?: InputMaybe<Scalars['String']>;
};

export type LaunchAdminTopic = {
  __typename?: 'LaunchAdminTopic';
  contentUids?: Maybe<Array<Maybe<Scalars['String']>>>;
  launchAdminPhase: LaunchAdminPhase;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LaunchAdminTopicData = {
  contentUids?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  phasePrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: InputMaybe<Scalars['String']>;
};

export type LaunchData = {
  isAttendee: Scalars['Boolean'];
  isBoardMember: Scalars['Boolean'];
  isContributor: Scalars['Boolean'];
  isTeamLeader: Scalars['Boolean'];
  isVolunteer: Scalars['Boolean'];
  launchNotes?: InputMaybe<Scalars['String']>;
};

export type LaunchPhase = {
  __typename?: 'LaunchPhase';
  description?: Maybe<Scalars['String']>;
  descriptionEs?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  launchAdminPhase?: Maybe<LaunchAdminPhase>;
  launchProject: LaunchProject;
  launchTopics: Array<LaunchTopic>;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LaunchProject = {
  __typename?: 'LaunchProject';
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  financeEnd?: Maybe<Scalars['Date']>;
  financeStart?: Maybe<Scalars['Date']>;
  fundAccount?: Maybe<FundAccount>;
  goalAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  launchAdminTemplate?: Maybe<LaunchAdminTemplate>;
  launchDate?: Maybe<Scalars['Date']>;
  launchPhases: Array<LaunchPhase>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  prefixedId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LaunchProjectData = {
  city?: InputMaybe<Scalars['String']>;
  financeEnd?: InputMaybe<Scalars['String']>;
  financeStart?: InputMaybe<Scalars['String']>;
  fundAccountPrefixedId?: InputMaybe<Scalars['String']>;
  goalAmount?: InputMaybe<Scalars['Float']>;
  launchDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  templatePrefixedId?: InputMaybe<Scalars['String']>;
};

export type LaunchTask = {
  __typename?: 'LaunchTask';
  checkedAt?: Maybe<Scalars['Date']>;
  checkedBy?: Maybe<Scalars['ID']>;
  isChecked: Scalars['Boolean'];
  isNotApplicable: Scalars['Boolean'];
  launchAdminTask?: Maybe<LaunchAdminTask>;
  launchTopic: LaunchTopic;
  memo?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LaunchTaskData = {
  memo: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
  topicPrefixedId?: InputMaybe<Scalars['ID']>;
};

export type LaunchTopic = {
  __typename?: 'LaunchTopic';
  launchAdminTopic?: Maybe<LaunchAdminTopic>;
  launchPhase: LaunchPhase;
  launchTasks: Array<LaunchTask>;
  nextTopic?: Maybe<LaunchTopic>;
  order: Scalars['Int'];
  prefixedId: Scalars['ID'];
  previousTopic?: Maybe<LaunchTopic>;
  title: Scalars['String'];
  titleEs?: Maybe<Scalars['String']>;
};

export type LetterTemplate = {
  __typename?: 'LetterTemplate';
  canBeRemoved: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  json_data?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  organization: Organization;
  prefixedId: Scalars['ID'];
  title: Scalars['String'];
};

export type Module = {
  __typename?: 'Module';
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  modulePrices?: Maybe<Array<ModulePrice>>;
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
};

export type ModulePrice = {
  __typename?: 'ModulePrice';
  amount: Scalars['Float'];
  frequency: Scalars['String'];
  module?: Maybe<Module>;
  prefixedId: Scalars['ID'];
  stripePriceId: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activeFinance?: Maybe<Scalars['Boolean']>;
  addChildToFamily: Family;
  addGuardianToFamily: Family;
  addPersonToGroup: Group;
  addPersonToOrganization: Scalars['Boolean'];
  checkLaunchTasks: Scalars['Boolean'];
  clearLaunchProject: Scalars['Boolean'];
  completeTutorialStep: Scalars['Boolean'];
  connectStripe: ConnectStripeResult;
  convertPersonToDonorOrganization: DonorOrganization;
  createAffiliateCode: AffiliateCode;
  createAttendance: Attendance;
  createAttendanceLocation: AttendanceLocation;
  createAttendanceType: AttendanceType;
  createContribution: Contribution;
  createDeposit: Deposit;
  createDepositAccount: DepositAccount;
  createDonorOrganization: DonorOrganization;
  createEventTemplate: EventTemplate;
  createFamily: Family;
  createFundAccount: FundAccount;
  createGroup: Group;
  createLaunchAdminPhase: LaunchAdminPhase;
  createLaunchAdminTask: LaunchAdminTask;
  createLaunchAdminTemplate: LaunchAdminTemplate;
  createLaunchAdminTopic: LaunchAdminTopic;
  createLaunchProject: Scalars['Boolean'];
  createLaunchTask: LaunchTask;
  createLetterTemplate: LetterTemplate;
  createOrganization: Organization;
  createPerson: Person;
  createRole: Role;
  createStripeSetupIntent?: Maybe<Scalars['String']>;
  createUser: CreateUserResult;
  deleteAttendance?: Maybe<Scalars['Boolean']>;
  deleteAttendanceDetail?: Maybe<Scalars['Boolean']>;
  deleteAttendanceLocation: Scalars['Boolean'];
  deleteAttendanceType: Scalars['Boolean'];
  deleteAttendances?: Maybe<Scalars['Boolean']>;
  deleteContribution?: Maybe<Scalars['Boolean']>;
  deleteContributionFund?: Maybe<Scalars['Boolean']>;
  deleteContributions?: Maybe<Scalars['Boolean']>;
  deleteDeposit?: Maybe<Scalars['Boolean']>;
  deleteDepositAccount?: Maybe<Scalars['Boolean']>;
  deleteDonorOrganization?: Maybe<Scalars['Boolean']>;
  deleteEventTemplate?: Maybe<Scalars['Boolean']>;
  deleteFundAccount?: Maybe<Scalars['Boolean']>;
  deleteGroup?: Maybe<Scalars['Boolean']>;
  deleteLaunchAdminPhase: Scalars['Boolean'];
  deleteLaunchAdminTask: Scalars['Boolean'];
  deleteLaunchAdminTopic: Scalars['Boolean'];
  deleteLetterTemplate?: Maybe<Scalars['Boolean']>;
  deleteOrganization: Scalars['Boolean'];
  deletePaymentMethod?: Maybe<Scalars['Boolean']>;
  deletePerson: Scalars['Boolean'];
  deletePersonFromFamily: Person;
  deletePersonFromGroup: Group;
  deleteRecurringGiving: Scalars['Boolean'];
  deleteRole: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteUserInvite: Scalars['Boolean'];
  inactiveFinance?: Maybe<Scalars['Boolean']>;
  mergePeople: Scalars['Boolean'];
  pauseRecurringGiving: RecurringGiving;
  recordActivity?: Maybe<Scalars['Boolean']>;
  refundContribution?: Maybe<Scalars['Boolean']>;
  removeLetterTemplateLogo?: Maybe<Scalars['Boolean']>;
  removeUserAccess: Scalars['Boolean'];
  reorderGroups?: Maybe<Scalars['Boolean']>;
  reorderLaunchAdminPhases: Scalars['Boolean'];
  reorderLaunchAdminTasks: Scalars['Boolean'];
  reorderLaunchAdminTemplates: Scalars['Boolean'];
  reorderLaunchAdminTopics: Scalars['Boolean'];
  sendAdconWelcomeEmail: Scalars['Boolean'];
  sendContributionStatementReport?: Maybe<Scalars['Boolean']>;
  sendResetPasswordEmail: Scalars['Boolean'];
  setPrimaryOrganization: Scalars['Boolean'];
  setupBilling?: Maybe<Subscription>;
  startKdsMigration?: Maybe<Scalars['Boolean']>;
  toggleActiveCheckIn: Scalars['Boolean'];
  toggleActiveGroup?: Maybe<Scalars['Boolean']>;
  toggleActiveLaunch: Scalars['Boolean'];
  toggleActiveLaunchAdminPhase: Scalars['Boolean'];
  toggleActiveLaunchAdminTemplate: Scalars['Boolean'];
  toggleAffiliateCode: AffiliateCode;
  toggleArchiveDepositAccount?: Maybe<Scalars['Boolean']>;
  toggleArchiveFundAccount?: Maybe<Scalars['Boolean']>;
  toggleNotApplicable: Scalars['Boolean'];
  uncheckLaunchTasks: Scalars['Boolean'];
  updateAdconAccountId?: Maybe<Tenant>;
  updateAffiliateCode: AffiliateCode;
  updateAttendance: Attendance;
  updateAttendanceLocation: AttendanceLocation;
  updateAttendanceType: AttendanceType;
  updateBilling?: Maybe<Scalars['Boolean']>;
  updateChild: Family;
  updateContentUids: Scalars['Boolean'];
  updateContribution?: Maybe<Contribution>;
  updateCurrentTenant: User;
  updateDeposit: Deposit;
  updateDepositAccount: DepositAccount;
  updateDonor: User;
  updateDonorOrganization: DonorOrganization;
  updateEventTemplate: EventTemplate;
  updateFundAccount: FundAccount;
  updateGroup: Group;
  updateGuardian: Family;
  updateLaunchAdminPhase: LaunchAdminPhase;
  updateLaunchAdminTask: LaunchAdminTask;
  updateLaunchAdminTemplate: LaunchAdminTemplate;
  updateLaunchAdminTopic: LaunchAdminTopic;
  updateLaunchProfile: Scalars['Boolean'];
  updateLaunchProject: Scalars['Boolean'];
  updateLaunchTask: LaunchTask;
  updateLaunchTaskMemo: Scalars['Boolean'];
  updateLetterTemplate: LetterTemplate;
  updateOnlineGiving: Scalars['Boolean'];
  updateOrganization: Organization;
  updatePaymentMethod: PaymentMethod;
  updatePerson: Person;
  updatePrimaryFamily: Family;
  updateRecurringGiving: RecurringGiving;
  updateRole: Role;
  updateTenantAdminWelcomeComplete?: Maybe<Scalars['Boolean']>;
  updateUser: User;
  updateUserFinanceWelcomeComplete?: Maybe<Scalars['Boolean']>;
  updateUserHaloWelcomeComplete?: Maybe<Scalars['Boolean']>;
  updateUserRoles: Scalars['Boolean'];
};


export type MutationActiveFinanceArgs = {
  donorPrefixedId: Scalars['ID'];
};


export type MutationAddChildToFamilyArgs = {
  birthdate?: InputMaybe<Scalars['String']>;
  familyPrefixedId: Scalars['ID'];
  grade?: InputMaybe<Scalars['String']>;
  isGuest: Scalars['Boolean'];
  medicalNote?: InputMaybe<Scalars['String']>;
  personPrefixedId: Scalars['ID'];
};


export type MutationAddGuardianToFamilyArgs = {
  familyPrefixedId: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  personPrefixedId: Scalars['ID'];
  phone?: InputMaybe<ContactPhoneInput>;
};


export type MutationAddPersonToGroupArgs = {
  backgroundCheck?: InputMaybe<Scalars['String']>;
  groupPrefixedId?: InputMaybe<Scalars['ID']>;
  groupType: Scalars['String'];
  personPrefixedId: Scalars['ID'];
};


export type MutationAddPersonToOrganizationArgs = {
  organizationPrefixedId: Scalars['ID'];
  personPrefixedId: Scalars['ID'];
};


export type MutationCheckLaunchTasksArgs = {
  prefixedIds: Array<Scalars['String']>;
  projectPrefixedId: Scalars['String'];
};


export type MutationCompleteTutorialStepArgs = {
  step: Scalars['Int'];
};


export type MutationConnectStripeArgs = {
  stripeOAuthCode?: InputMaybe<Scalars['String']>;
};


export type MutationConvertPersonToDonorOrganizationArgs = {
  personPrefixedId: Scalars['ID'];
};


export type MutationCreateAffiliateCodeArgs = {
  code: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAttendanceArgs = {
  attendanceDetails?: InputMaybe<Array<AttendanceDetailInput>>;
  attendanceTypePrefixedId: Scalars['ID'];
  date: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateAttendanceLocationArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateAttendanceTypeArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateContributionArgs = {
  contributionFunds?: InputMaybe<Array<ContributionFundInput>>;
  coverProcessingFee?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['String']>;
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  donorTypeLabel?: InputMaybe<Scalars['String']>;
  exchangeAmount?: InputMaybe<Scalars['Float']>;
  exchangeDescription?: InputMaybe<Scalars['String']>;
  includeProcessorFee?: InputMaybe<Scalars['Boolean']>;
  isExchange?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateDepositArgs = {
  contributions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['String']>;
  depositAccountPrefixedId?: InputMaybe<Scalars['ID']>;
  memo?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateDepositAccountArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDonorOrganizationArgs = {
  activeFinance?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isResumed?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationCreateEventTemplateArgs = {
  eventType: Scalars['String'];
  groupPrefixedIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};


export type MutationCreateFamilyArgs = {
  personPrefixedId: Scalars['ID'];
  phone?: InputMaybe<ContactPhoneInput>;
};


export type MutationCreateFundAccountArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isOnlineGivingVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationCreateGroupArgs = {
  description?: InputMaybe<Scalars['String']>;
  groupType: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateLaunchAdminPhaseArgs = {
  launchAdminPhaseData?: InputMaybe<LaunchAdminPhaseData>;
};


export type MutationCreateLaunchAdminTaskArgs = {
  launchAdminTaskData?: InputMaybe<LaunchAdminTaskData>;
};


export type MutationCreateLaunchAdminTemplateArgs = {
  launchAdminTemplateData?: InputMaybe<LaunchAdminTemplateData>;
};


export type MutationCreateLaunchAdminTopicArgs = {
  launchAdminTopicData?: InputMaybe<LaunchAdminTopicData>;
};


export type MutationCreateLaunchProjectArgs = {
  launchProjectData?: InputMaybe<LaunchProjectData>;
};


export type MutationCreateLaunchTaskArgs = {
  launchTaskData?: InputMaybe<LaunchTaskData>;
};


export type MutationCreateLetterTemplateArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  json_data?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOrganizationArgs = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePersonArgs = {
  contactInput?: InputMaybe<ContactInput>;
  personInput?: InputMaybe<PersonInput>;
};


export type MutationCreateRoleArgs = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationCreateUserArgs = {
  address?: InputMaybe<Scalars['String']>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isResumed?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
  personPrefixedId?: InputMaybe<Scalars['ID']>;
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  roles: Array<InputMaybe<Scalars['ID']>>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAttendanceArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteAttendanceDetailArgs = {
  attendancePrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationDeleteAttendanceLocationArgs = {
  attendanceLocationPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteAttendanceTypeArgs = {
  attendanceTypePrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteAttendancesArgs = {
  prefixedIds: Array<Scalars['ID']>;
};


export type MutationDeleteContributionArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteContributionFundArgs = {
  contributionPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationDeleteContributionsArgs = {
  prefixedIds: Array<Scalars['ID']>;
};


export type MutationDeleteDepositArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteDepositAccountArgs = {
  depositAccountPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteDonorOrganizationArgs = {
  donorOrganizationPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteEventTemplateArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteFundAccountArgs = {
  fundAccountPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteGroupArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteLaunchAdminPhaseArgs = {
  phasePrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteLaunchAdminTaskArgs = {
  taskPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteLaunchAdminTopicArgs = {
  topicPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteLetterTemplateArgs = {
  letterTemplatePrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type MutationDeleteOrganizationArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeletePaymentMethodArgs = {
  organizationPrefixedId: Scalars['ID'];
  processorId: Scalars['String'];
};


export type MutationDeletePersonArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeletePersonFromFamilyArgs = {
  familyPrefixedId: Scalars['ID'];
  personPrefixedId: Scalars['ID'];
};


export type MutationDeletePersonFromGroupArgs = {
  groupPrefixedId: Scalars['ID'];
  personPrefixedId: Scalars['ID'];
};


export type MutationDeleteRecurringGivingArgs = {
  organizationPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationDeleteUserInviteArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationInactiveFinanceArgs = {
  donorPrefixedId: Scalars['ID'];
};


export type MutationMergePeopleArgs = {
  loserPrefixedId: Scalars['ID'];
  winnerPrefixedId: Scalars['ID'];
};


export type MutationPauseRecurringGivingArgs = {
  organizationPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationRecordActivityArgs = {
  message: Scalars['String'];
};


export type MutationRefundContributionArgs = {
  prefixedId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveLetterTemplateLogoArgs = {
  letterTemplatePrefixedId: Scalars['ID'];
};


export type MutationRemoveUserAccessArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationReorderGroupsArgs = {
  prefixedIds: Array<Scalars['ID']>;
};


export type MutationReorderLaunchAdminPhasesArgs = {
  launchAdminPhases: Array<ReorderInput>;
};


export type MutationReorderLaunchAdminTasksArgs = {
  launchAdminTasks: Array<ReorderInput>;
};


export type MutationReorderLaunchAdminTemplatesArgs = {
  launchAdminTemplates: Array<ReorderInput>;
};


export type MutationReorderLaunchAdminTopicsArgs = {
  launchAdminTopics: Array<ReorderInput>;
};


export type MutationSendAdconWelcomeEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendContributionStatementReportArgs = {
  donorPrefixedIds?: InputMaybe<Array<Scalars['ID']>>;
  filters: ContributionFilters;
  letterTemplatePrefixedId: Scalars['ID'];
  mode: Scalars['String'];
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationSetPrimaryOrganizationArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationSetupBillingArgs = {
  address?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  billingEmail: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  organizationName: Scalars['String'];
  paymentMethodId: Scalars['ID'];
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  productName: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationStartKdsMigrationArgs = {
  uuid: Scalars['ID'];
};


export type MutationToggleActiveCheckInArgs = {
  personPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationToggleActiveGroupArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationToggleActiveLaunchArgs = {
  personPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationToggleActiveLaunchAdminPhaseArgs = {
  isActive: Scalars['Boolean'];
  prefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationToggleActiveLaunchAdminTemplateArgs = {
  isActive: Scalars['Boolean'];
  prefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationToggleAffiliateCodeArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationToggleArchiveDepositAccountArgs = {
  depositAccountPrefixedId: Scalars['ID'];
};


export type MutationToggleArchiveFundAccountArgs = {
  fundAccountPrefixedId: Scalars['ID'];
};


export type MutationToggleNotApplicableArgs = {
  direction: Scalars['Boolean'];
  prefixedId: Scalars['String'];
};


export type MutationUncheckLaunchTasksArgs = {
  prefixedIds: Array<Scalars['String']>;
  projectPrefixedId: Scalars['String'];
};


export type MutationUpdateAdconAccountIdArgs = {
  adconAccountId?: InputMaybe<Scalars['ID']>;
  prefixedId: Scalars['ID'];
};


export type MutationUpdateAffiliateCodeArgs = {
  code: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  type: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAttendanceArgs = {
  attendanceDetails?: InputMaybe<Array<AttendanceDetailInput>>;
  attendanceTypePrefixedId: Scalars['ID'];
  date: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationUpdateAttendanceLocationArgs = {
  attendanceLocationPrefixedId: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationUpdateAttendanceTypeArgs = {
  attendanceTypePrefixedId: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationUpdateBillingArgs = {
  organizationPrefixedId: Scalars['ID'];
  removedProductsIds?: InputMaybe<Array<Scalars['ID']>>;
  selectedProductsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateChildArgs = {
  birthdate?: InputMaybe<Scalars['String']>;
  familyPrefixedId: Scalars['ID'];
  firstName: Scalars['String'];
  grade?: InputMaybe<Scalars['String']>;
  isGuest: Scalars['Boolean'];
  lastName: Scalars['String'];
  medicalNote?: InputMaybe<Scalars['String']>;
  personPrefixedId: Scalars['ID'];
};


export type MutationUpdateContentUidsArgs = {
  topicPrefixedId: Scalars['String'];
  uids: Array<Scalars['String']>;
};


export type MutationUpdateContributionArgs = {
  contributionFunds?: InputMaybe<Array<ContributionFundInput>>;
  coverProcessingFee?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['String']>;
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  donorTypeLabel?: InputMaybe<Scalars['String']>;
  exchangeAmount?: InputMaybe<Scalars['Float']>;
  exchangeDescription?: InputMaybe<Scalars['String']>;
  includeProcessorFee?: InputMaybe<Scalars['Boolean']>;
  isExchange?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
};


export type MutationUpdateCurrentTenantArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationUpdateDepositArgs = {
  date?: InputMaybe<Scalars['String']>;
  depositAccountPrefixedId?: InputMaybe<Scalars['ID']>;
  memo?: InputMaybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
};


export type MutationUpdateDepositAccountArgs = {
  depositAccountPrefixedId: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDonorArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDonorOrganizationArgs = {
  activeFinance?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  donorOrganizationPrefixedId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateEventTemplateArgs = {
  groupPrefixedIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  prefixedId: Scalars['String'];
};


export type MutationUpdateFundAccountArgs = {
  fundAccountPrefixedId: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isOnlineGivingVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
};


export type MutationUpdateGroupArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
};


export type MutationUpdateGuardianArgs = {
  familyPrefixedId: Scalars['ID'];
  firstName: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  lastName: Scalars['String'];
  personPrefixedId: Scalars['ID'];
  phone?: InputMaybe<ContactPhoneInput>;
};


export type MutationUpdateLaunchAdminPhaseArgs = {
  launchAdminPhaseData?: InputMaybe<LaunchAdminPhaseData>;
};


export type MutationUpdateLaunchAdminTaskArgs = {
  launchAdminTaskData?: InputMaybe<LaunchAdminTaskData>;
};


export type MutationUpdateLaunchAdminTemplateArgs = {
  launchAdminTemplateData?: InputMaybe<LaunchAdminTemplateData>;
};


export type MutationUpdateLaunchAdminTopicArgs = {
  launchAdminTopicData?: InputMaybe<LaunchAdminTopicData>;
};


export type MutationUpdateLaunchProfileArgs = {
  launchData?: InputMaybe<LaunchData>;
  personPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateLaunchProjectArgs = {
  launchProjectData?: InputMaybe<LaunchProjectData>;
};


export type MutationUpdateLaunchTaskArgs = {
  launchTaskData?: InputMaybe<LaunchTaskData>;
};


export type MutationUpdateLaunchTaskMemoArgs = {
  memo?: InputMaybe<Scalars['String']>;
  prefixedId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateLetterTemplateArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  json_data?: InputMaybe<Scalars['String']>;
  letterTemplatePrefixedId: Scalars['ID'];
  logoUrl?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOnlineGivingArgs = {
  address?: InputMaybe<Scalars['String']>;
  backgroundUrl?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  enableCoverProcessingFee: Scalars['Boolean'];
  fundAccountInfo: Array<FundAccountInput>;
  isPublished: Scalars['Boolean'];
  legalName?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  organizationPrefixedId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  returnUrl?: InputMaybe<Scalars['String']>;
  showDisplayNameAtTop: Scalars['Boolean'];
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationArgs = {
  adconOrganizationId?: InputMaybe<Scalars['ID']>;
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<ContactPhoneInput>>;
  prefixedId: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePaymentMethodArgs = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cardholderName: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  expDate: Scalars['String'];
  nickname?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  processorId: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePersonArgs = {
  backgroundCheck?: InputMaybe<Scalars['String']>;
  contactInput?: InputMaybe<ContactInput>;
  personInput?: InputMaybe<PersonInput>;
};


export type MutationUpdatePrimaryFamilyArgs = {
  familyPrefixedId: Scalars['ID'];
  personPrefixedId: Scalars['ID'];
};


export type MutationUpdateRecurringGivingArgs = {
  amountsByFundAccount: Array<AmountByFundAccount>;
  isFeeCovered?: InputMaybe<Scalars['Boolean']>;
  memo?: InputMaybe<Scalars['String']>;
  nextOccurrence?: InputMaybe<Scalars['Date']>;
  organizationPrefixedId: Scalars['ID'];
  prefixedId: Scalars['ID'];
  stripeCardExpiration: Scalars['String'];
  stripeCardLastFour: Scalars['String'];
  stripePaymentMethodId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  prefixedId: Scalars['ID'];
};


export type MutationUpdateTenantAdminWelcomeCompleteArgs = {
  prefixedId: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
};


export type MutationUpdateUserRolesArgs = {
  prefixedId: Scalars['ID'];
  roles: Array<UserRoleInput>;
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String'];
  causer?: Maybe<User>;
  channel: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  status: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationFilters = {
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type NotificationsResult = {
  __typename?: 'NotificationsResult';
  items: Array<Notification>;
  totalResults: Scalars['Int'];
};

export type OnlineGiving = {
  __typename?: 'OnlineGiving';
  address?: Maybe<Scalars['String']>;
  backgroundUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  enableCoverProcessingFee?: Maybe<Scalars['Boolean']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  maximumDate?: Maybe<Scalars['DateTime']>;
  minimumDate?: Maybe<Scalars['DateTime']>;
  nextPage?: Maybe<Scalars['String']>;
  organization: Organization;
  phone?: Maybe<Scalars['String']>;
  processorAccountId?: Maybe<Scalars['String']>;
  processorType?: Maybe<Scalars['String']>;
  replyToEmail?: Maybe<Scalars['String']>;
  returnUrl?: Maybe<Scalars['String']>;
  showDisplayNameAtTop?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  unpublishedAt?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['String']>;
};

export type OnlineGivingIntegration = {
  __typename?: 'OnlineGivingIntegration';
  hasChargesEnabled: Scalars['Boolean'];
  isConnected: Scalars['Boolean'];
  isPullingData: Scalars['Boolean'];
  lastImportedContribution?: Maybe<Scalars['DateTime']>;
  minimumImportDate?: Maybe<Scalars['DateTime']>;
  onlineGiving?: Maybe<OnlineGiving>;
};

export type OnlineGivingReportResult = {
  __typename?: 'OnlineGivingReportResult';
  givingInDateRange: Scalars['Float'];
  onlineGiving?: Maybe<OnlineGiving>;
  totalGiving: Scalars['Float'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Organization = {
  __typename?: 'Organization';
  adconOrganizationId?: Maybe<Scalars['ID']>;
  availableModules?: Maybe<Array<Module>>;
  billingUrl?: Maybe<Scalars['String']>;
  canBeRemoved: Scalars['Boolean'];
  category?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstLetter?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  isStripeConnected: Scalars['Boolean'];
  kdsMigrationQueue?: Maybe<KdsMigrationQueue>;
  language?: Maybe<Scalars['String']>;
  launchProject?: Maybe<LaunchProject>;
  name: Scalars['String'];
  onlineGiving?: Maybe<OnlineGiving>;
  pivot?: Maybe<OrganizationDonorPivot>;
  pmLastFour?: Maybe<Scalars['String']>;
  pmType?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  stripeId?: Maybe<Scalars['String']>;
  systemAdminOrganizationUrl: Scalars['String'];
  tenant?: Maybe<Tenant>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationDonorPivot = {
  __typename?: 'OrganizationDonorPivot';
  activeCheckIn?: Maybe<Scalars['Boolean']>;
  activeFinance?: Maybe<Scalars['Boolean']>;
  activeLaunch?: Maybe<Scalars['Boolean']>;
  archivedCheckInAt?: Maybe<Scalars['DateTime']>;
  archivedFinanceAt?: Maybe<Scalars['DateTime']>;
  archivedLaunchAt?: Maybe<Scalars['DateTime']>;
  isAttendee?: Maybe<Scalars['Boolean']>;
  isBoardMember?: Maybe<Scalars['Boolean']>;
  isContributor?: Maybe<Scalars['Boolean']>;
  isTeamLeader?: Maybe<Scalars['Boolean']>;
  isVolunteer?: Maybe<Scalars['Boolean']>;
  launchNotes?: Maybe<Scalars['String']>;
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  createdAt?: Maybe<Scalars['Date']>;
  donor: Donor;
  expiration?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  prefixedId: Scalars['ID'];
  primary: Scalars['Boolean'];
  processorId: Scalars['String'];
  type: Scalars['String'];
};

export type PeopleFilters = {
  byPrefixedId?: InputMaybe<Array<Scalars['ID']>>;
  groupType?: InputMaybe<Scalars['String']>;
  launchTeams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  noAddress?: InputMaybe<Scalars['Boolean']>;
  noEmail?: InputMaybe<Scalars['Boolean']>;
  noPhone?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  showActiveCheckIn?: InputMaybe<Scalars['Boolean']>;
  showActiveGiving?: InputMaybe<Scalars['Boolean']>;
  showActiveLaunch?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type PeopleResult = {
  __typename?: 'PeopleResult';
  allPrefixedIds: Array<Scalars['String']>;
  items: Array<Person>;
  totalResults: Scalars['Int'];
};

export type Permission = {
  __typename?: 'Permission';
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
  roles: Array<Role>;
  updatedAt: Scalars['DateTime'];
};

export type Person = {
  __typename?: 'Person';
  anniversary?: Maybe<Scalars['String']>;
  backgroundCheck?: Maybe<Attribute>;
  birthdate?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  contributions?: Maybe<Array<Maybe<Contribution>>>;
  families?: Maybe<Array<Family>>;
  firstName: Scalars['String'];
  grade?: Maybe<Attribute>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  medicalNote?: Maybe<Attribute>;
  notes?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Organization>>;
  pivot?: Maybe<FamilyPersonPivot>;
  prefixedId: Scalars['ID'];
  primaryFamily?: Maybe<Family>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  tenant: Tenant;
  user?: Maybe<User>;
};

export type PersonInput = {
  anniversary?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  prefixedId?: InputMaybe<Scalars['ID']>;
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  modulePrices: Array<ModulePrice>;
  name: Scalars['String'];
  prefixedId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  S3PresignedUrl: Scalars['String'];
  activityLogs?: Maybe<ActivityLogsResult>;
  affiliateCodes?: Maybe<AffiliateCodeResult>;
  attendance?: Maybe<Attendance>;
  attendanceLocation?: Maybe<AttendanceLocation>;
  attendanceLocations?: Maybe<Array<AttendanceLocation>>;
  attendanceType?: Maybe<AttendanceType>;
  attendanceTypes?: Maybe<Array<AttendanceType>>;
  attendances?: Maybe<AttendancesResult>;
  billingDetails?: Maybe<BillingDetails>;
  canDonorOrganizationBeRemoved?: Maybe<Scalars['Boolean']>;
  canPersonBeRemoved?: Maybe<Scalars['Boolean']>;
  canUserBeRemoved?: Maybe<Scalars['Boolean']>;
  contribution?: Maybe<Contribution>;
  contributionFunds?: Maybe<ContributionFundsResult>;
  contributionFundsReport?: Maybe<Scalars['String']>;
  contributions?: Maybe<ContributionsResult>;
  contributionsByFundReport?: Maybe<ChartReportResult>;
  contributionsReport?: Maybe<ChartReportResult>;
  contributionsStatementReport?: Maybe<Scalars['String']>;
  contributionsTotal?: Maybe<ContributionsTotalResult>;
  contributionsTotalReport?: Maybe<Scalars['String']>;
  deposit: Deposit;
  depositAccount?: Maybe<DepositAccount>;
  depositAccounts?: Maybe<Array<DepositAccount>>;
  deposits?: Maybe<DepositsResult>;
  donor?: Maybe<Donor>;
  donorContributions?: Maybe<DonorContributionsResult>;
  donorContributionsReport?: Maybe<Scalars['String']>;
  donorDashboardReport?: Maybe<DonorDashboardReport>;
  donorLabels: Array<Scalars['String']>;
  donorOrganization?: Maybe<DonorOrganization>;
  donorOrganizations?: Maybe<DonorOrganizationsResult>;
  donorPaymentMethods: Array<PaymentMethod>;
  donorRecurringGivings?: Maybe<DonorRecurringGivingsResult>;
  donors?: Maybe<DonorsResult>;
  donorsReport: Scalars['String'];
  donorsSummaryReport?: Maybe<DonorsSummaryReportResult>;
  eventTemplate?: Maybe<EventTemplate>;
  eventTemplates?: Maybe<Array<EventTemplate>>;
  financeReport?: Maybe<FinanceReportResult>;
  fundAccount?: Maybe<FundAccount>;
  fundAccounts?: Maybe<Array<FundAccount>>;
  getKdsOrganizationByUuid?: Maybe<KdsOrganization>;
  getKdsOrganizationName: Scalars['String'];
  getKdsRecordsCount?: Maybe<KdsTablesResult>;
  givingTutorialProgress: Array<TutorialData>;
  group?: Maybe<Group>;
  groups?: Maybe<Array<Group>>;
  kdsMigrationQueue?: Maybe<KdsMigrationQueue>;
  launchAdminPhase?: Maybe<LaunchAdminPhase>;
  launchAdminPhases: Array<LaunchAdminPhase>;
  launchAdminTasks: Array<LaunchAdminTask>;
  launchAdminTemplate?: Maybe<LaunchAdminTemplate>;
  launchAdminTemplates: Array<LaunchAdminTemplate>;
  launchAdminTopic?: Maybe<LaunchAdminTopic>;
  launchAdminTopics: Array<LaunchAdminTopic>;
  launchBoardReport: Scalars['String'];
  launchProject?: Maybe<LaunchProject>;
  launchTopic?: Maybe<LaunchTopic>;
  launchTopicContent?: Maybe<Array<Maybe<ContentBlock>>>;
  letterTemplate?: Maybe<LetterTemplate>;
  letterTemplates?: Maybe<Array<LetterTemplate>>;
  me: User;
  notifications: NotificationsResult;
  onlineGiving?: Maybe<OnlineGiving>;
  onlineGivingIntegration?: Maybe<OnlineGivingIntegration>;
  onlineGivingReport?: Maybe<OnlineGivingReportResult>;
  organization?: Maybe<Organization>;
  organizationByAdconId?: Maybe<Organization>;
  organizationRecurringGivings?: Maybe<DonorRecurringGivingsResult>;
  organizations: Array<Organization>;
  paymentMethods: Array<PaymentMethod>;
  people?: Maybe<PeopleResult>;
  peopleReport: Scalars['String'];
  permissions: Array<Permission>;
  person?: Maybe<Person>;
  previewBilling?: Maybe<BillingDetails>;
  products: Array<Product>;
  recentActivity?: Maybe<Array<Maybe<DonorActivity>>>;
  role?: Maybe<Role>;
  roles: Array<Role>;
  searchParams?: Maybe<AlgoliaSearchParams>;
  tenant?: Maybe<Tenant>;
  tenantByAdconId?: Maybe<Tenant>;
  tenantPeople?: Maybe<Array<Maybe<Person>>>;
  tenantsByLetter: Array<TenantsByLetter>;
  user?: Maybe<User>;
  users: UsersResult;
  validTenant?: Maybe<Scalars['Boolean']>;
};


export type QueryS3PresignedUrlArgs = {
  command: Scalars['String'];
  directory: Scalars['String'];
  fileName: Scalars['String'];
};


export type QueryActivityLogsArgs = {
  page: Scalars['Int'];
  pageLength?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
  type: Scalars['String'];
};


export type QueryAffiliateCodesArgs = {
  filters?: InputMaybe<AffiliateCodeFilters>;
};


export type QueryAttendanceArgs = {
  attendancePrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryAttendanceLocationArgs = {
  attendanceLocationPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryAttendanceLocationsArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryAttendanceTypeArgs = {
  attendanceTypePrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryAttendanceTypesArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryAttendancesArgs = {
  filters?: InputMaybe<AttendancesFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryBillingDetailsArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryCanDonorOrganizationBeRemovedArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryCanPersonBeRemovedArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryCanUserBeRemovedArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryContributionArgs = {
  contributionPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryContributionFundsArgs = {
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ContributionFundsFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryContributionFundsReportArgs = {
  filters: ContributionFundsFilters;
  organizationPrefixedId: Scalars['ID'];
  type: Scalars['String'];
};


export type QueryContributionsArgs = {
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ContributionFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryContributionsByFundReportArgs = {
  filters?: InputMaybe<ContributionsReportFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryContributionsReportArgs = {
  filters?: InputMaybe<ContributionsReportFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryContributionsStatementReportArgs = {
  action: Scalars['String'];
  donorPrefixedIds?: InputMaybe<Array<Scalars['ID']>>;
  filters: ContributionFilters;
  letterTemplatePrefixedId: Scalars['ID'];
  mode: Scalars['String'];
};


export type QueryContributionsTotalArgs = {
  filters?: InputMaybe<ContributionsTotalFilters>;
};


export type QueryContributionsTotalReportArgs = {
  filters: ContributionsTotalFilters;
  type: Scalars['String'];
};


export type QueryDepositArgs = {
  depositPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDepositAccountArgs = {
  depositAccountPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDepositAccountsArgs = {
  organizationPrefixedId: Scalars['ID'];
  showArchived: Scalars['Boolean'];
};


export type QueryDepositsArgs = {
  filters?: InputMaybe<DepositFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDonorArgs = {
  donorPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDonorContributionsArgs = {
  filters?: InputMaybe<DonorContributionFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryDonorContributionsReportArgs = {
  filters: DonorContributionFilters;
  organizationPrefixedId: Scalars['ID'];
  type: Scalars['String'];
};


export type QueryDonorDashboardReportArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDonorLabelsArgs = {
  filters?: InputMaybe<DonorFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
  template: Scalars['String'];
};


export type QueryDonorOrganizationArgs = {
  donorOrganizationPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDonorOrganizationsArgs = {
  filters?: InputMaybe<DonorOrganizationFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryDonorRecurringGivingsArgs = {
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<DonorRecurringGivingFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryDonorsArgs = {
  filters?: InputMaybe<DonorFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryDonorsReportArgs = {
  filters: DonorFilters;
  type: Scalars['String'];
};


export type QueryDonorsSummaryReportArgs = {
  depositPrefixedId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryEventTemplateArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryEventTemplatesArgs = {
  filters?: InputMaybe<EventTemplateFilters>;
};


export type QueryFinanceReportArgs = {
  filters?: InputMaybe<FinanceReportFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryFundAccountArgs = {
  fundAccountPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryFundAccountsArgs = {
  organizationPrefixedId: Scalars['ID'];
  showArchived: Scalars['Boolean'];
};


export type QueryGetKdsOrganizationByUuidArgs = {
  uuid: Scalars['ID'];
};


export type QueryGetKdsRecordsCountArgs = {
  uuid: Scalars['ID'];
};


export type QueryGivingTutorialProgressArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryGroupArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryGroupsArgs = {
  filters?: InputMaybe<GroupFilters>;
};


export type QueryKdsMigrationQueueArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminPhaseArgs = {
  phasePrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminPhasesArgs = {
  templatePrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminTasksArgs = {
  topicPrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminTemplateArgs = {
  templatePrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminTopicArgs = {
  topicPrefixedId: Scalars['ID'];
};


export type QueryLaunchAdminTopicsArgs = {
  phasePrefixedId: Scalars['ID'];
};


export type QueryLaunchBoardReportArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryLaunchTopicArgs = {
  topicPrefixedId: Scalars['ID'];
};


export type QueryLaunchTopicContentArgs = {
  forAdmin: Scalars['Boolean'];
  topicPrefixedId: Scalars['ID'];
};


export type QueryLetterTemplateArgs = {
  letterTemplatePrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryLetterTemplatesArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  filters: NotificationFilters;
  personPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryOnlineGivingArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryOnlineGivingReportArgs = {
  endDate: Scalars['String'];
  organizationPrefixedId: Scalars['ID'];
  startDate: Scalars['String'];
};


export type QueryOrganizationArgs = {
  prefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrganizationByAdconIdArgs = {
  adconOrganizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryOrganizationRecurringGivingsArgs = {
  donorPrefixedId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<DonorRecurringGivingFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryPaymentMethodsArgs = {
  donorPrefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
};


export type QueryPeopleArgs = {
  filters?: InputMaybe<PeopleFilters>;
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
};


export type QueryPeopleReportArgs = {
  filters: PeopleFilters;
  type: Scalars['String'];
};


export type QueryPersonArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryPreviewBillingArgs = {
  organizationPrefixedId: Scalars['ID'];
  removedProductsIds?: InputMaybe<Array<Scalars['ID']>>;
  selectedProductsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRecentActivityArgs = {
  organizationPrefixedId: Scalars['ID'];
};


export type QueryRoleArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryTenantArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryTenantByAdconIdArgs = {
  adconAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryTenantPeopleArgs = {
  filters?: InputMaybe<TenantPeopleFilters>;
  organizationPrefixedId: Scalars['ID'];
};


export type QueryTenantsByLetterArgs = {
  filters?: InputMaybe<TenantFilters>;
};


export type QueryUserArgs = {
  prefixedId: Scalars['ID'];
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilters>;
};

export type RecurringGiving = {
  __typename?: 'RecurringGiving';
  computedAmount: Scalars['Float'];
  computedFee: Scalars['Float'];
  computedNetAmount: Scalars['Float'];
  donor: Donor;
  fundAccounts?: Maybe<Array<RecurringGivingFundAccount>>;
  isFeeCovered: Scalars['Boolean'];
  lastChargeAttemptFailed: Scalars['Boolean'];
  lastOccurrence?: Maybe<Scalars['Date']>;
  memo?: Maybe<Scalars['String']>;
  nextOccurrence?: Maybe<Scalars['Date']>;
  organization: Organization;
  paymentMethod: PaymentMethod;
  prefixedId: Scalars['ID'];
  schedule?: Maybe<RecurringGivingSchedule>;
};

export type RecurringGivingFundAccount = {
  __typename?: 'RecurringGivingFundAccount';
  isDefault: Scalars['Boolean'];
  isOnlineGivingVisible: Scalars['Boolean'];
  name: Scalars['String'];
  pivot: RecurringGivingFundAccountPivot;
  prefixedId: Scalars['ID'];
};

export type RecurringGivingFundAccountPivot = {
  __typename?: 'RecurringGivingFundAccountPivot';
  amount: Scalars['Float'];
  netAmount: Scalars['Float'];
};

export type RecurringGivingSchedule = {
  __typename?: 'RecurringGivingSchedule';
  startDate: Scalars['Date'];
  type: ScheduleTypes;
};

export type ReorderInput = {
  order?: InputMaybe<Scalars['Int']>;
  prefixedId: Scalars['ID'];
};

export type ReportResultItem = {
  __typename?: 'ReportResultItem';
  name: Scalars['String'];
  newValue?: Maybe<Scalars['Float']>;
  oldValue?: Maybe<Scalars['Float']>;
  prefixedId?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  accountAdmin?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  isTenantRole?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  permissions?: Maybe<Array<Permission>>;
  pivot?: Maybe<RoleTeamPivot>;
  prefixedId: Scalars['ID'];
  teamId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RoleTeam = {
  __typename?: 'RoleTeam';
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  prefixedId: Scalars['ID'];
  tenantId: Scalars['ID'];
  tenantPrefixedId: Scalars['ID'];
};

export type RoleTeamPivot = {
  __typename?: 'RoleTeamPivot';
  roleId?: Maybe<Scalars['ID']>;
  teamId?: Maybe<Scalars['ID']>;
};

export enum ScheduleTypes {
  EveryOtherWeek = 'every_other_week',
  Monthly = 'monthly',
  TwiceAMonth = 'twice_a_month',
  Weekly = 'weekly'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  isValid?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  status: Scalars['String'];
  trialEndsAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  amount: Scalars['Float'];
  cancelAt?: Maybe<Scalars['DateTime']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCanceled?: Maybe<Scalars['Boolean']>;
  isCanceling?: Maybe<Scalars['Boolean']>;
  module?: Maybe<Module>;
  startedOn: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  adconAccountId?: Maybe<Scalars['ID']>;
  adminTeamId: Scalars['ID'];
  adminWelcomeComplete?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organizations?: Maybe<Array<Organization>>;
  owner?: Maybe<User>;
  prefixedId: Scalars['ID'];
  primaryOrganization: Organization;
  secondaryOrganizations?: Maybe<Array<Organization>>;
  systemAdminTenantUsersUrl: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TenantFilters = {
  search?: InputMaybe<Scalars['String']>;
};

export type TenantPeopleFilters = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type TenantsByLetter = {
  __typename?: 'TenantsByLetter';
  firstLetter: Scalars['String'];
  tenants: Array<Tenant>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TutorialData = {
  __typename?: 'TutorialData';
  complete: Scalars['Boolean'];
  step: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  abilities: Array<Scalars['String']>;
  canLogin?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  donorOrganization?: Maybe<DonorOrganization>;
  email?: Maybe<Scalars['String']>;
  financeWelcomeComplete?: Maybe<Scalars['Boolean']>;
  haloWelcomeComplete: Scalars['Boolean'];
  invites?: Maybe<Array<Invite>>;
  isHaloAdmin: Scalars['Boolean'];
  launchProject?: Maybe<LaunchProject>;
  person?: Maybe<Person>;
  prefixedId: Scalars['ID'];
  roles?: Maybe<Array<Role>>;
  rolesTeams?: Maybe<Array<RoleTeam>>;
  tenant?: Maybe<Tenant>;
  tenants?: Maybe<Array<Tenant>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserFilters = {
  byOrganization?: InputMaybe<Scalars['ID']>;
  byPrefixedId?: InputMaybe<Array<Scalars['ID']>>;
  includeTenantAdmins?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageLength?: InputMaybe<Scalars['Int']>;
  person?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showActiveLaunch?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
};

export type UserRoleInput = {
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
  rolePrefixedId: Scalars['ID'];
};

export type UsersResult = {
  __typename?: 'UsersResult';
  allItems: Array<User>;
  items: Array<User>;
  totalResults: Scalars['Int'];
};

export type DonorContributionsQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  filters?: InputMaybe<DonorContributionFilters>;
}>;


export type DonorContributionsQuery = { __typename?: 'Query', donorContributions?: { __typename?: 'DonorContributionsResult', totalResults: number, items: Array<{ __typename?: 'ContributionWithFundAccountNames', prefixedId: string, date: any, amount?: number | null, memo?: string | null, refundedAt?: any | null, refundReason?: string | null, fundAccountNames?: string | null, recurringGiving?: { __typename?: 'RecurringGiving', prefixedId: string } | null }> } | null };

export type DonorContributionsReportQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  filters: DonorContributionFilters;
  type: Scalars['String'];
}>;


export type DonorContributionsReportQuery = { __typename?: 'Query', donorContributionsReport?: string | null };

export type ContributionQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  contributionPrefixedId: Scalars['ID'];
}>;


export type ContributionQuery = { __typename?: 'Query', contribution?: { __typename?: 'Contribution', prefixedId: string, date: any, media: string, memo?: string | null, amount?: number | null, netAmount?: number | null, fee?: number | null, coverProcessingFee: boolean, isExchange: boolean, exchangeAmount?: number | null, exchangeDescription?: string | null, donorPrefixedId: string, donorTypeLabel: string, processorPaymentId?: string | null, isDeposited?: boolean | null, refundedAt?: any | null, refundReason?: string | null, donor: { __typename: 'DonorOrganization', prefixedId: string, name: string } | { __typename: 'Person', prefixedId: string, firstName: string, lastName: string, imageUrl?: string | null, birthdate?: string | null, anniversary?: string | null, notes?: string | null, contact?: { __typename?: 'Contact', email?: string | null } | null }, organization: { __typename?: 'Organization', prefixedId: string, name: string }, contributionFunds?: Array<{ __typename?: 'ContributionFund', prefixedId: string, amount: number, netAmount: number, fee: number, isDeductible: boolean, fundAccount: { __typename?: 'FundAccount', prefixedId: string, name: string } }> | null } | null };

export type DonorDashboardReportQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
}>;


export type DonorDashboardReportQuery = { __typename?: 'Query', donorDashboardReport?: { __typename?: 'DonorDashboardReport', totalGifts: number, activeRecurringGifts: number, singleGifts: number } | null };

export type RecentActivityQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
}>;


export type RecentActivityQuery = { __typename?: 'Query', recentActivity?: Array<{ __typename?: 'DonorActivity', type?: string | null, description?: string | null, date?: any | null, amount?: number | null } | null> | null };

export type S3PresignedUrlQueryVariables = Exact<{
  command: Scalars['String'];
  directory: Scalars['String'];
  fileName: Scalars['String'];
}>;


export type S3PresignedUrlQuery = { __typename?: 'Query', S3PresignedUrl: string };

export type UpdateDonorMutationVariables = Exact<{
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDonorMutation = { __typename?: 'Mutation', updateDonor: { __typename?: 'User', prefixedId: string } };

export type SendContributionStatementReportMutationVariables = Exact<{
  donorPrefixedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filters: ContributionFilters;
  letterTemplatePrefixedId: Scalars['ID'];
  mode: Scalars['String'];
}>;


export type SendContributionStatementReportMutation = { __typename?: 'Mutation', sendContributionStatementReport?: boolean | null };

export type PersonDataFragment = { __typename?: 'Person', firstName: string, lastName: string, imageUrl?: string | null, birthdate?: string | null, anniversary?: string | null, notes?: string | null };

export type ContactPhoneFragment = { __typename?: 'ContactPhone', phone?: string | null, type?: string | null, contactAgreementAccepted?: boolean | null, isPrimary?: boolean | null, prefixedId: string };

export type ContactDataFragment = { __typename?: 'Contact', address?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, email?: string | null, phones?: Array<{ __typename?: 'ContactPhone', phone?: string | null, type?: string | null, contactAgreementAccepted?: boolean | null, isPrimary?: boolean | null, prefixedId: string } | null> | null };

export type FundAccountsQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  showArchived: Scalars['Boolean'];
}>;


export type FundAccountsQuery = { __typename?: 'Query', fundAccounts?: Array<{ __typename?: 'FundAccount', prefixedId: string, name: string, isDefault: boolean, isOnlineGivingVisible: boolean, archivedAt?: any | null }> | null };

export type LetterTemplatesQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
}>;


export type LetterTemplatesQuery = { __typename?: 'Query', letterTemplates?: Array<{ __typename?: 'LetterTemplate', prefixedId: string, title: string, json_data?: string | null, isPrimary: boolean }> | null };

export type LetterTemplateQueryVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  letterTemplatePrefixedId: Scalars['ID'];
}>;


export type LetterTemplateQuery = { __typename?: 'Query', letterTemplate?: { __typename?: 'LetterTemplate', prefixedId: string, title: string, json_data?: string | null, isPrimary: boolean, canBeRemoved: boolean } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', prefixedId: string, email?: string | null, abilities: Array<string>, isHaloAdmin: boolean, tenant?: { __typename?: 'Tenant', id: string, prefixedId: string, primaryOrganization: { __typename?: 'Organization', prefixedId: string, name: string, isStripeConnected: boolean, availableModules?: Array<{ __typename?: 'Module', prefixedId: string, name: string, displayName: string }> | null, onlineGiving?: { __typename?: 'OnlineGiving', logoUrl?: string | null } | null, contact?: { __typename?: 'Contact', address?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, email?: string | null, phones?: Array<{ __typename?: 'ContactPhone', phone?: string | null, type?: string | null, contactAgreementAccepted?: boolean | null, isPrimary?: boolean | null, prefixedId: string } | null> | null } | null } } | null, person?: { __typename?: 'Person', prefixedId: string, firstName: string, lastName: string, imageUrl?: string | null, birthdate?: string | null, anniversary?: string | null, notes?: string | null, contact?: { __typename?: 'Contact', prefixedId: string, email?: string | null } | null } | null } };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', donorPaymentMethods: Array<{ __typename?: 'PaymentMethod', processorId: string, nickname?: string | null, primary: boolean }> };

export type UpdatePaymentMethodMutationVariables = Exact<{
  processorId: Scalars['String'];
  nickname?: InputMaybe<Scalars['String']>;
  cardholderName: Scalars['String'];
  expDate: Scalars['String'];
  primary?: InputMaybe<Scalars['Boolean']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod: { __typename?: 'PaymentMethod', processorId: string, nickname?: string | null, primary: boolean } };

export type DeletePaymentMethodMutationVariables = Exact<{
  organizationPrefixedId: Scalars['ID'];
  processorId: Scalars['String'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: boolean | null };

export type DonorRecurringGivingsQueryVariables = Exact<{
  organizationPrefixedId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<DonorRecurringGivingFilters>;
}>;


export type DonorRecurringGivingsQuery = { __typename?: 'Query', donorRecurringGivings?: { __typename?: 'DonorRecurringGivingsResult', totalResults: number, items: Array<{ __typename?: 'RecurringGiving', prefixedId: string, lastOccurrence?: any | null, nextOccurrence?: any | null, computedAmount: number, computedNetAmount: number, computedFee: number, isFeeCovered: boolean, memo?: string | null, lastChargeAttemptFailed: boolean, schedule?: { __typename?: 'RecurringGivingSchedule', type: ScheduleTypes, startDate: any } | null, donor: { __typename: 'DonorOrganization', prefixedId: string, name: string, contact?: { __typename?: 'Contact', email?: string | null } | null } | { __typename: 'Person', prefixedId: string, firstName: string, lastName: string, imageUrl?: string | null, birthdate?: string | null, anniversary?: string | null, notes?: string | null, contact?: { __typename?: 'Contact', email?: string | null } | null }, organization: { __typename?: 'Organization', prefixedId: string, name: string }, fundAccounts?: Array<{ __typename?: 'RecurringGivingFundAccount', prefixedId: string, name: string, isDefault: boolean, isOnlineGivingVisible: boolean, pivot: { __typename?: 'RecurringGivingFundAccountPivot', amount: number, netAmount: number } }> | null, paymentMethod: { __typename?: 'PaymentMethod', prefixedId: string, processorId: string, type: string, lastFour?: string | null, expiration?: string | null } }> } | null };

export type PauseRecurringGivingMutationVariables = Exact<{
  prefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
}>;


export type PauseRecurringGivingMutation = { __typename?: 'Mutation', pauseRecurringGiving: { __typename?: 'RecurringGiving', prefixedId: string } };

export type UpdateRecurringGivingMutationVariables = Exact<{
  prefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
  stripePaymentMethodId: Scalars['String'];
  stripeCardLastFour: Scalars['String'];
  stripeCardExpiration: Scalars['String'];
  type: Scalars['String'];
  amountsByFundAccount: Array<AmountByFundAccount> | AmountByFundAccount;
  nextOccurrence?: InputMaybe<Scalars['Date']>;
  isFeeCovered?: InputMaybe<Scalars['Boolean']>;
  memo?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRecurringGivingMutation = { __typename?: 'Mutation', updateRecurringGiving: { __typename?: 'RecurringGiving', prefixedId: string } };

export type DeleteRecurringGivingMutationVariables = Exact<{
  prefixedId: Scalars['ID'];
  organizationPrefixedId: Scalars['ID'];
}>;


export type DeleteRecurringGivingMutation = { __typename?: 'Mutation', deleteRecurringGiving: boolean };

export type UserQueryVariables = Exact<{
  prefixedId: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', prefixedId: string, email?: string | null, person?: { __typename?: 'Person', prefixedId: string, firstName: string, lastName: string, imageUrl?: string | null, birthdate?: string | null, anniversary?: string | null, notes?: string | null, contact?: { __typename?: 'Contact', address?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, email?: string | null, phones?: Array<{ __typename?: 'ContactPhone', phone?: string | null, type?: string | null, contactAgreementAccepted?: boolean | null, isPrimary?: boolean | null, prefixedId: string } | null> | null } | null, organizations?: Array<{ __typename?: 'Organization', prefixedId: string }> | null } | null, tenant?: { __typename?: 'Tenant', prefixedId: string, owner?: { __typename?: 'User', prefixedId: string } | null } | null } | null };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type SendAdconWelcomeEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendAdconWelcomeEmailMutation = { __typename?: 'Mutation', sendAdconWelcomeEmail: boolean };

export const PersonDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"personData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"anniversary"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<PersonDataFragment, unknown>;
export const ContactPhoneFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contactPhone"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContactPhone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"contactAgreementAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]} as unknown as DocumentNode<ContactPhoneFragment, unknown>;
export const ContactDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contactData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactPhone"}}]}}]}},...ContactPhoneFragmentDoc.definitions]} as unknown as DocumentNode<ContactDataFragment, unknown>;
export const DonorContributionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"donorContributions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DonorContributionFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"donorContributions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"refundedAt"}},{"kind":"Field","name":{"kind":"Name","value":"refundReason"}},{"kind":"Field","name":{"kind":"Name","value":"fundAccountNames"}},{"kind":"Field","name":{"kind":"Name","value":"recurringGiving"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<DonorContributionsQuery, DonorContributionsQueryVariables>;
export const DonorContributionsReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"donorContributionsReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DonorContributionFilters"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"donorContributionsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}]}}]} as unknown as DocumentNode<DonorContributionsReportQuery, DonorContributionsReportQueryVariables>;
export const ContributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contributionPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contributionPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contributionPrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"netAmount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"coverProcessingFee"}},{"kind":"Field","name":{"kind":"Name","value":"isExchange"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"donorPrefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"donorTypeLabel"}},{"kind":"Field","name":{"kind":"Name","value":"processorPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"isDeposited"}},{"kind":"Field","name":{"kind":"Name","value":"donor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personData"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DonorOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributionFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"netAmount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"isDeductible"}},{"kind":"Field","name":{"kind":"Name","value":"fundAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"refundedAt"}},{"kind":"Field","name":{"kind":"Name","value":"refundReason"}}]}}]}},...PersonDataFragmentDoc.definitions]} as unknown as DocumentNode<ContributionQuery, ContributionQueryVariables>;
export const DonorDashboardReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DonorDashboardReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"donorDashboardReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalGifts"}},{"kind":"Field","name":{"kind":"Name","value":"activeRecurringGifts"}},{"kind":"Field","name":{"kind":"Name","value":"singleGifts"}}]}}]}}]} as unknown as DocumentNode<DonorDashboardReportQuery, DonorDashboardReportQueryVariables>;
export const RecentActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecentActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recentActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<RecentActivityQuery, RecentActivityQueryVariables>;
export const S3PresignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"S3PresignedUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"command"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"directory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"S3PresignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"command"},"value":{"kind":"Variable","name":{"kind":"Name","value":"command"}}},{"kind":"Argument","name":{"kind":"Name","value":"directory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"directory"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}]}}]} as unknown as DocumentNode<S3PresignedUrlQuery, S3PresignedUrlQueryVariables>;
export const UpdateDonorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDonor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password_confirmation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDonor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"image_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"password_confirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password_confirmation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}}]} as unknown as DocumentNode<UpdateDonorMutation, UpdateDonorMutationVariables>;
export const SendContributionStatementReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendContributionStatementReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"donorPrefixedIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContributionFilters"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"letterTemplatePrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendContributionStatementReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donorPrefixedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"donorPrefixedIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"letterTemplatePrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"letterTemplatePrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mode"}}}]}]}}]} as unknown as DocumentNode<SendContributionStatementReportMutation, SendContributionStatementReportMutationVariables>;
export const FundAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fundAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showArchived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"showArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showArchived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isOnlineGivingVisible"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]} as unknown as DocumentNode<FundAccountsQuery, FundAccountsQueryVariables>;
export const LetterTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"letterTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"letterTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"json_data"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}}]}}]}}]} as unknown as DocumentNode<LetterTemplatesQuery, LetterTemplatesQueryVariables>;
export const LetterTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"letterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"letterTemplatePrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"letterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"letterTemplatePrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"letterTemplatePrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"json_data"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"canBeRemoved"}}]}}]}}]} as unknown as DocumentNode<LetterTemplateQuery, LetterTemplateQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"abilities"}},{"kind":"Field","name":{"kind":"Name","value":"isHaloAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"availableModules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlineGiving"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isStripeConnected"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactData"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personData"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},...ContactDataFragmentDoc.definitions,...PersonDataFragmentDoc.definitions]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const PaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"donorPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processorId"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const UpdatePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nickname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardholderName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressLine1"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressLine2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"processorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"nickname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nickname"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardholderName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardholderName"}}},{"kind":"Argument","name":{"kind":"Name","value":"expDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"primary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primary"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressLine1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressLine1"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressLine2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressLine2"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processorId"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"processorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processorId"}}}]}]}}]} as unknown as DocumentNode<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const DonorRecurringGivingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"donorRecurringGivings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DonorRecurringGivingFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"donorRecurringGivings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastOccurrence"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}},{"kind":"Field","name":{"kind":"Name","value":"computedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"computedNetAmount"}},{"kind":"Field","name":{"kind":"Name","value":"computedFee"}},{"kind":"Field","name":{"kind":"Name","value":"isFeeCovered"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"lastChargeAttemptFailed"}},{"kind":"Field","name":{"kind":"Name","value":"donor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personData"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DonorOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isOnlineGivingVisible"}},{"kind":"Field","name":{"kind":"Name","value":"pivot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"netAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"processorId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}}]}}]}}]}}]}},...PersonDataFragmentDoc.definitions]} as unknown as DocumentNode<DonorRecurringGivingsQuery, DonorRecurringGivingsQueryVariables>;
export const PauseRecurringGivingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pauseRecurringGiving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseRecurringGiving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}}]} as unknown as DocumentNode<PauseRecurringGivingMutation, PauseRecurringGivingMutationVariables>;
export const UpdateRecurringGivingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecurringGiving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripePaymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardLastFour"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardExpiration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amountsByFundAccount"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmountByFundAccount"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextOccurrence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFeeCovered"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecurringGiving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stripePaymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripePaymentMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stripeCardLastFour"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardLastFour"}}},{"kind":"Argument","name":{"kind":"Name","value":"stripeCardExpiration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeCardExpiration"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"amountsByFundAccount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amountsByFundAccount"}}},{"kind":"Argument","name":{"kind":"Name","value":"nextOccurrence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextOccurrence"}}},{"kind":"Argument","name":{"kind":"Name","value":"isFeeCovered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFeeCovered"}}},{"kind":"Argument","name":{"kind":"Name","value":"memo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}}]} as unknown as DocumentNode<UpdateRecurringGivingMutation, UpdateRecurringGivingMutationVariables>;
export const DeleteRecurringGivingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRecurringGiving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRecurringGiving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationPrefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationPrefixedId"}}}]}]}}]} as unknown as DocumentNode<DeleteRecurringGivingMutation, DeleteRecurringGivingMutationVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prefixedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prefixedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"personData"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contactData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefixedId"}}]}}]}}]}}]}},...PersonDataFragmentDoc.definitions,...ContactDataFragmentDoc.definitions]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const SendResetPasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendResetPasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendResetPasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SendAdconWelcomeEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendAdconWelcomeEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAdconWelcomeEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<SendAdconWelcomeEmailMutation, SendAdconWelcomeEmailMutationVariables>;